import { get, post, patchWrapped } from "./client";
import type { Client } from "../types/client";

interface ClientListData {
  clients: Client[];
  total: number;
}

export async function listClients(): Promise<Client[]> {
  const result = await get<ClientListData>("/api/clients/");
  return result.clients;
}

export async function getClient(clientId: number): Promise<Client> {
  return get<Client>(`/api/clients/${clientId}`);
}

export async function updateClient(
  clientId: number,
  fields: {
    business_name?: string;
    business_type?: string;
    industry?: string;
  },
): Promise<Client> {
  return patchWrapped<Client>(`/api/clients/${clientId}`, fields);
}

export async function createClient(
  businessName: string,
  businessType: string,
  industry: string = "general",
): Promise<Client> {
  return post<Client>("/api/clients/", {
    business_name: businessName,
    business_type: businessType,
    industry,
  });
}
